import {
  RESET_QUEUE_ACCESSORIES_COUNT,
  ADD_QUEUE_ACCESSORIES_COUNT,
  ADD_QUEUE_NCP_COUNT,
  RESET_QUEUE_NCP_COUNT,
  ADD_QUEUE_PROMO_COUNT,
  RESET_QUEUE_PROMO_COUNT,
  ADD_QUEUE_COUPON_SERVICE_COUNT,
  RESET_QUEUE_COUPON_SERVICE_COUNT,
  ADD_QUEUE_PACKAGE_SERVICE_COUNT,
  RESET_QUEUE_PACKAGE_SERVICE_COUNT,
  ADD_QUEUE_CART_COUNT,
  RESET_QUEUE_CART_COUNT,
  ADD_QUEUE_GLOBAL_COUNT,
  RESET_QUEUE_GLOBAL_COUNT,
  RESET_QUEUE_PRODUCT_KNOWLEDGE_COUNT,
  ADD_QUEUE_PRODUCT_KNOWLEDGE_COUNT,
  ADD_QUEUE_NCL_COUNT,
  RESET_QUEUE_NCL_COUNT,
  RESET_QUEUE_GAMIFICATION_COUNT,
  ADD_QUEUE_GAMIFICATION_COUNT,
} from './constants';

// Accessories
export const addQueueAccessoriesCount = () => ({
  type: ADD_QUEUE_ACCESSORIES_COUNT,
});

export const resetQueueAccessoriesCount = () => ({
  type: RESET_QUEUE_ACCESSORIES_COUNT,
});

// New Car List
export const addQueueNCLCount = () => ({
  type: ADD_QUEUE_NCL_COUNT,
});

export const resetQueueNCLCount = () => ({
  type: RESET_QUEUE_NCL_COUNT,
});

// New Car Purchase
export const addQueueNCPCount = () => ({
  type: ADD_QUEUE_NCP_COUNT,
});

export const resetQueueNCPCount = () => ({
  type: RESET_QUEUE_NCP_COUNT,
});

// Promo
export const addQueuePromoCount = () => ({
  type: ADD_QUEUE_PROMO_COUNT,
});

export const resetQueuePromoCount = () => ({
  type: RESET_QUEUE_PROMO_COUNT,
});

// Coupon Service
export const addQueueCouponServiceCount = () => ({
  type: ADD_QUEUE_COUPON_SERVICE_COUNT,
});

export const resetQueueCouponServiceCount = () => ({
  type: RESET_QUEUE_COUPON_SERVICE_COUNT,
});

// Package Service
export const addQueuePackageServiceCount = () => ({
  type: ADD_QUEUE_PACKAGE_SERVICE_COUNT,
});

export const resetQueuePackageServiceCount = () => ({
  type: RESET_QUEUE_PACKAGE_SERVICE_COUNT,
});

// Cart
export const addQueueCartCount = () => ({
  type: ADD_QUEUE_CART_COUNT,
});

export const resetQueueCartCount = () => ({
  type: RESET_QUEUE_CART_COUNT,
});

// Global
export const addQueueGlobalCount = () => ({
  type: ADD_QUEUE_GLOBAL_COUNT,
});

export const resetQueueGlobalCount = () => ({
  type: RESET_QUEUE_GLOBAL_COUNT,
});

// Product Knowledge
export const addQueueProductKnowledgeCount = () => ({
  type: ADD_QUEUE_PRODUCT_KNOWLEDGE_COUNT,
});

export const resetQueueProductKnowledgeCount = () => ({
  type: RESET_QUEUE_PRODUCT_KNOWLEDGE_COUNT,
});

// Gamification
export const addQueueGamificationCount = () => ({
  type: ADD_QUEUE_GAMIFICATION_COUNT,
});

export const resetQueueGamificationCount = () => ({
  type: RESET_QUEUE_GAMIFICATION_COUNT,
});
